import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { AuthConsumer } from '../../providers/AuthProvider';

class Logout extends Component {
  render() {
    return (
      <AuthConsumer>
        {({ logout }) => {
          logout();
          return;
        }}
      </AuthConsumer>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Logout));
